import React from 'react';
import './App.css'; // Import your global CSS if needed
import ParagraphWordCounter from './ParagraphWordCounter';

function App() {
  return (
    <div className="App">
      <ParagraphWordCounter />
    </div>
  );
}

export default App;

